import { GetCandidateSourcesDocument, GetCandidateSourcesQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type CandidateSource = GetCandidateSourcesQuery['ats']['candidateSources'][number]

export const useCandidateSources = () => {
  const { data, loading } = useQuery(GetCandidateSourcesDocument)

  return {
    loading,
    candidateSources: data ? data.ats.candidateSources : [],
  }
}
